var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Upload',{attrs:{"action":"//","before-upload":_vm.handleUpload}},[_vm._t("default",function(){return [_c('Button',{attrs:{"icon":"ios-cloud-upload-outline","loading":_vm.loadingStatus}},[_vm._v("\n      表格导入\n    ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }